const angular = require('angular');
const app = angular.module('learn-directives');
var dragula = require('../../../../node_modules/dragula/dragula');

/**
 * Defines the add to news component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('trackSection', ['Application', 'Authorization', 'AdminContent', 'Assessments', '$translate', function (Application, Authorization, AdminContent, Assessments, $translate) {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      section: '=',
      fullTrack: '=',
      sectionChange: '&',
      removeSection: '&',
      noChange: '&',
      createTrack: '&',
      saveTrack: '&',
    },
    template: require('../../../templates/directives/cms/track-section.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.assessments = Authorization.getAuthToken().company.assessments || false;
      self.scorm = Authorization.getAuthToken().company.scorm || false;
      self.translations = {};
      self.omittedContentTypes = ['workshop', 'track', 'survey', 'journey', 'imported_content'];
      self.sectionId = $scope.section._id || $scope.fullTrack.sections.length.toString();

      self.mediumOpts = {
        'targetBlank': true,
        'toolbar': {
          'buttons': ['bold', 'italic', 'underline', 'anchor', 'h1', 'h2', 'h3', 'quote', 'unorderedlist', 'orderedlist']
        }
      };

      self.typeOptions = [];

      var typeList = ['article', 'file', 'video', 'quiz', 'assessment', 'scorm'];

      self.getTitle = function (item) {
        var type = null;
        for (var i = 0; i < typeList.length; i++) {
          if (item && item[typeList[i]] && item[typeList[i]].title) {
            return item[typeList[i]].title.replace('<b>','').replace('</b>','');
          }
        }
        return '';
      };

      self.getNewlyCreatedContentId = function(course) {
        for (const type of typeList) {
          if (course[type]) {
            return course[type]._id;
          }
        }
      }


      $scope.$watch('editSection.courseType', function(newVal, oldVal) {
        if (!newVal) {
          return;
        }
        self.titlesLoad = true;

        // Get items
        self.findTitles(newVal)
        .then(function(results) {
          var items = results && results.data || [];
          items.sort(function(a, b) {
            if (a.title.toLowerCase() < b.title.toLowerCase()) {
              return -1;
            }
            if (a.title.toLowerCase() > b.title.toLowerCase()) {
              return 1;
            }
            return 1;
          });
          var options = [];
          angular.forEach(items, function(item) {
            var username = item.user && item.user.full_name ? ' - ' + item.user.full_name : '';
            options.push({name: '<b>' + item.title + '</b>' + username, value: item._id});
          });

          self.titlesLoad = false;
          self.titleOptions = options;
        });
      });


      self.onAdd = async function(items) {
        const courses = [];
        let containsAssessment = false;
        
        let counter = 1;
        for (let item of items) {
          if (item.type === 'assessment') {
            containsAssessment = true;
            const duplicatedAssessment = await self.assessmentAdd(item._id);
            item = duplicatedAssessment;
          }
          const course = {
            position: $scope.section.courses.length + counter,
            contentId: item._id
          }
          
          course[item.type] = {
            _id: item._id,
            title: item.name || item.title,
          }
          
          courses.push(course);
          $scope.fullTrack.allCourseIds.push(item._id);
          counter++;
        }
        
        $scope.section.courses.push(...courses);
        self.showAddContentModal = false;
        if (containsAssessment) {
          $scope.$apply();
        }
      };

      self.assessmentAdd = async function(assessmentId) {
        try {
          self.assessmentLoading = true;
          var body = {};
          if ($scope.fullTrack && $scope.fullTrack._id) {
            body.content = {
              content_type: 'Track',
              content_id: $scope.fullTrack._id
            }
          }
          const assessment = await Assessments.duplicate({subresource: assessmentId}, body).$promise
          self.assessmentLoading = false;
          return assessment; 
        } catch (error) {
          console.log('error: ', error);
        };
      };

      self.findTitles = function(type) {
        return AdminContent.find({
          subresource: '',
          sort: 'title,1',
          'user-populate': 'first_name,last_name,full_name,email',
          types: type === 'scorm' ? type : type + 's'
        }).$promise;
      };

      self.removeCourse = function() {
        // remove the course and drop the position for each one thereafter
        if (!self.courseToRemove && self.courseToRemove !== 0) {
          return;
        }

        var index;
        angular.forEach($scope.section.courses, function(course, i) {
          if (course.position === self.courseToRemove) {
            index = i;
            return;
          }
          if (course.position > self.courseToRemove) {
            course.position = course.position - 1;
          }
        });
        $scope.section.courses.splice(index, 1);
        self.courseToRemove = false;
        self.showRemovalConfirmation = false;
      };

      self.deleteSection = function() {
        $scope.removeSection({section: $scope.section});
      };

      self.moveSection = function(direction) {
        $scope.sectionChange({section: $scope.section, direction: direction});
      };

      self.addNewCourse = function(type) {
        $scope.noChange({temp:'change'});
        var addIt = function() {
          var typeBlock = {
            article: 'articles',
            video: 'videos',
            file: 'files',
            quiz: 'quizzes',
            scorm: 'scorm',
            imported_content: 'imported_content',
            assessment: 'assessments'
          };
          if (!$scope.fullTrack._id) {
            return;
          }
          var state = {
            track: $scope.fullTrack._id,
            trackTitle: $scope.fullTrack.name,
            contentType: type,
            contentId: null,
            contentTitle: null,
            section: $scope.section.position,
            contentPosition: $scope.section.courses.length + 1,
            ttl: new Date().valueOf() + 5000
          };

          $scope.saveTrack({item:'save'})
          .then(function(track) {
            Application.trackState.set(state);
            Application.navigation.goTo('/edit/' + typeBlock[type]);
          });
        };
        if (!$scope.fullTrack._id) {
          $scope.createTrack({item:'create'})
          .then(function(track) {
            $scope.fullTrack._id = track._id;
            addIt();
          });
        } else {
          addIt();
        }
      };

      self.courseEdit = function(course) {
        var type = null;
        if (course.article) {
          type = 'article'; 
        }
        if (course.file) {
          type = 'file'; 
        }
        if (course.video) {
          type = 'video'; 
        }
        if (course.quiz) {
          type = 'quiz'; 
        }
        if (course.assessment) {
          type = 'assessment'; 
        }
        if (course.scorm) {
          type = 'scorm'; 
        }
        
        var typeBlock = {
          article: 'articles',
          video: 'videos',
          file: 'files',
          quiz: 'quizzes',
          assessment: 'assessments',
          scorm: 'scorm'
        };

        if (!$scope.fullTrack._id) {
          $scope.createTrack({item:'create'})
          .then(function(track) {
            $scope.noChange({temp:true});
            Application.trackState.set({track: track._id, trackTitle: track.name, ttl: new Date().valueOf() + 5000});
            Application.navigation.goTo('/edit/' + typeBlock[type] + '/' + course[type]._id);
          });
        } else {
          $scope.saveTrack({item:'save'})
          .then(function(track) {
            $scope.noChange({temp:true});
            Application.trackState.set({track: $scope.fullTrack._id, trackTitle: $scope.fullTrack.name, ttl: new Date().valueOf() + 5000});
            Application.navigation.goTo('/edit/' + typeBlock[type] + '/' + course[type]._id);
          });
        }
      };

      self.dragConfig = {
        dragManagement: null,
        create: function() {
          if (self.dragConfig.dragManagement && self.dragConfig.dragManagement.destroy) {
            self.dragConfig.dragManagement.destroy();
          }
          self.dragConfig.dragManagement = null;
          self.dragConfig.dragManagement = dragula({
            direction: 'vertical',
            copy: false,
            mirrorContainer: document.querySelectorAll('#mirror-course-manager-' + self.sectionId)[0]
          });
        },
        setDrag: function() {
          self.dragConfig.create();
          setTimeout(function() {
            self.dragConfig.dragManagement.containers = [];
            var selected = document.querySelectorAll('#course-manager-' + self.sectionId);
            for (var i = 0; i < selected.length; i++) {
              self.dragConfig.dragManagement.containers.push(selected[i]);
            }
            self.dragConfig.dragManagement.on('drop', function(el, target, source, sibling) {
              setTimeout(function() {
                self.dragConfig.reorder();
              }, 10);
            });
            $scope.$apply();
          }, 10);
        },
        reorder: function() {
          var selected = document.querySelectorAll('#course-manager-' + self.sectionId);
          var courses = {};

          function addCourse(course, position) {
            if (!course.id) {
              return;
            }
            courses[course.id] = {position: parseInt(position)};
          };

          for (var i = 0; i < selected.length; i++) {
            if (!selected[i].children) {
              continue;
            }
            for (var j = 0; j < selected[i].children.length; j++) {
              addCourse(selected[i].children[j], j)
            }
          }
          
          $scope.section.courses.forEach(function(item) {
            const id = item._id || item.contentId;
            if (id && courses[id]) {
              item.position = courses[id].position;
            } 
            if (!id && self.getNewlyCreatedContentId(item)) {
              const tempId = self.getNewlyCreatedContentId(item);
              item.position = courses[tempId].position;
            }
          });
          $scope.$apply();

        }
      }
      self.dragConfig.setDrag();

      $translate([
        'global.contentTypes.articles',
        'global.contentTypes.files',
        'global.contentTypes.videos',
        'global.contentTypes.assessments',
        'global.contentTypes.scorm',
      ]).then(function(translations) {
        self.translations = translations;
        self.typeOptions = [
          {
            name: self.translations['global.contentTypes.articles'],
            value: 'article'
          }, {
            name: self.translations['global.contentTypes.files'],
            value: 'file'
          }, {
            name: self.translations['global.contentTypes.videos'],
            value: 'video'
          }
        ];

        if (self.assessments) {
          self.typeOptions.push({
            name: self.translations['global.contentTypes.assessments'],
            value: 'assessment'
          });
        }

        if (self.scorm) {
          self.typeOptions.push({
            name: self.translations['global.contentTypes.scorm'],
            value: 'scorm'
          });
        }
      });

    }],
    controllerAs: 'editSection'
  };
}]);
